import { Controller } from 'stimulus'

/**
 * Localizes datetimes in a selectbox (StimulusJS controller)
 *
 * @class TimezoneUpdateController
 * @memberof Controllers
 */
export default class extends Controller {
  static targets = [ 'select', 'timezone' ]

  /**
   * @function Controllers.TimezoneUpdateController.connect
   * @memberof Controllers
   * @description Fires when this controller connects to a new DOM element
   */
  connect() {
    this._selectLocalTimezone()
  }

  /**
   * @function Controllers.TimezoneUpdateController.update
   * @memberof Controllers
   * @description Localize selection datetimes based on selected timezone
   */
  update() {
    const timezone = this.timezoneTarget.value

    this.selectTargets.forEach(selectTag => {
      selectTag.children.forEach(option => {
        if (option.value !== '') {
          option.text = this._timeInLocale(option.value, timezone)
        }
      })
    })
  }

  /**
   * @function Controllers.TimezoneUpdateController.select
   * @memberof Controllers
   * @description Enforce single selection amung all selectTargets
   * @param {Event} event - datetime selection
   */
  select(event) {
    this.selectTargets.forEach(selectTag => {
      if (event.target !== selectTag) {
        selectTag.selectedIndex = 0
      }
    })
  }

  //
  // "Private" methods
  //

  /**
   * @function Controllers.TimezoneUpdateController._timeInLocale
   * @memberof Controllers
   * @description Localize provided datetime string
   * @param {String} datetimeStr
   * @param {String} timezone
   * @return {String} localized datetime
   */
  _timeInLocale(datetimeStr, timezone) {
    // localeString format: "20/12/2012, 03:00:00 PM"
    const localeStr = new Date(datetimeStr).toLocaleString('en-US', { timeZone: timezone })

    return localeStr.split(', ')[1].replace(':00 ', ' ')
  }

  /**
   * @function Controllers.TimezoneUpdateController._selectLocalTimezone
   * @memberof Controllers
   * @description Guess user's timezone and select it
   */
  _selectLocalTimezone() {
    const offsetJSON = this.data.get('offsetsToZonesJson')
    if (!offsetJSON) {
      console.log('missing offset to timezone mapping')
      return
    }

    const offsetMap = JSON.parse(offsetJSON)
    const offsetGuess = (new Date()).getTimezoneOffset() / -60

    this.timezoneTarget.value = offsetMap[offsetGuess]
    this.update()
  }
}

